export enum Breakpoints {
  Landscape = '@media (min-width:0px) and (orientation: landscape)',
  Tablet = '@media (min-width:600px)',
}

export const AppBarOffset = 25;

export enum AppBarClearance {
  Base = 56 + AppBarOffset,
  Landscape = 48 + AppBarOffset,
  Tablet = 64 + AppBarOffset,
}



// WEBPACK FOOTER //
// ./src/utils/responsive.ts